import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { STEPS_STATUS } from "../steps/index.jsx";
import {
  KfIcon,
  KF_ICONS,
  ICON_SIZE,
  ICON_STROKE
} from "@widgets/common/components/primitives/kf_icon/index.jsx";
import { Spinner, SPINNER_SIZES } from "@widgets/feedback/index.jsx";
import { Show } from "@widgets/common/control_flow/index.jsx";

import styles from "./style.css";

export const ProgressSteps = ({ steps }) => {
  return (
    <div className={`${styles.steps} }`}>
      {steps.map((step, index) => (
        <Step
          details={step}
          key={index}
          isLastStep={index === steps.length - 1}
        />
      ))}
    </div>
  );
};

const Step = ({ details, isLastStep }) => {
  return (
    <div className={styles.step}>
      <div className={`${styles.stepIndicator} ${styles[details.status]}`}>
        <StatusIcon status={details.status} />
        <Show when={!isLastStep}>
          <div className={styles.stepLine} />
        </Show>
      </div>
      <div className={styles.stepData}>
        <div className={styles.stepTitle}>
          {details.title ? details.title : details.titleRenderer()}
        </div>
        <div className={styles.stepContent}>
          {details.content ? details.content : details.contentRenderer()}
        </div>
      </div>
    </div>
  );
};

const StatusIcon = ({ status }) => {
  switch (status) {
    case STEPS_STATUS.WAIT:
      return <div className={`${styles.circleIcon}`} />;
    case STEPS_STATUS.PROCESS:
      return (
        <div className={styles.circleIcon}>
          <Spinner size={SPINNER_SIZES.SMALL} />
        </div>
      );
    case STEPS_STATUS.FINISH:
      return (
        <div className={`${styles.circleIcon}`}>
          <KfIcon
            icon={KF_ICONS.CHECKMARK}
            size={ICON_SIZE.SIZE_16}
            stroke={ICON_STROKE.THIN}
            color={"--kf-color-bg-white"}
          />
        </div>
      );
    case STEPS_STATUS.ERROR:
      return (
        <div className={`${styles.circleIcon}`}>
          <KfIcon
            icon={KF_ICONS.CLOSE}
            size={ICON_SIZE.SIZE_16}
            stroke={ICON_STROKE.THIN}
            color={"--kf-color-bg-white"}
          />
        </div>
      );
    default:
      return null;
  }
};

const StepPropType = PropTypes.shape({
  status: PropTypes.oneOf(Object.values(STEPS_STATUS)),
  title: PropTypes.string,
  titleRenderer: PropTypes.node,
  content: PropTypes.string,
  contentRenderer: PropTypes.node
});

ProgressSteps.propTypes = {
  /** An array of objects is used to represent each step,
   * where each item have keys like status, title, content.
   *
   * Status is same as STEPS_STATUS used for Step component.
   *
   * Title and content can be custom rendered using titleRenderer and contentRenderer respectively
   **/
  steps: PropTypes.arrayOf(StepPropType)
};

Step.propTypes = {
  details: StepPropType,
  isLastStep: PropTypes.bool
};

StatusIcon.propTypes = {
  status: PropTypes.oneOf(Object.values(STEPS_STATUS))
};
